module.exports = __webpack_public_path__ + "static/media/header-experience.a6e91dc7.jpg";